/**
 * Created by andrey on 04.08.2025
 */

const TABS_ANIMATIONS = {
    base: function () {
        const icon = this.icon;
        if (!icon) {
            return;
        }

        const baseScale = icon.scale;
        const basePosition = icon.getPosition();
        const height = icon.height;

        icon.runAction(new cc.Spawn(
            new cc.Sequence(
                new cc.ScaleTo(0.12, 1.05, 1.15),
                new cc.ScaleTo(0.1, 1.08, 0.9),
                new cc.ScaleTo(0.08, 1, 1)
            ),
            new cc.Sequence(
                new cc.MoveBy(0.1, 0, height * 0.1),
                new cc.MoveBy(0.12, 0, -height * 0.14),
                new cc.MoveBy(0.08, 0, height * 0.04)
            )
        )).setFinalize(() => {
            icon.setPosition(basePosition);
            icon.setScale(baseScale);
        });
    },

    riddles: function () {
        const button = this;

        if (!button) {
            return;
        }

        const baseScale = button.scale;
        const basePosition = button.getPosition();

        const scaleUp = baseScale * 1.10;
        const scaleDown = baseScale * 0.95;

        button.runAction(new cc.Spawn(
            new cc.Sequence(
                cc.scaleTo(0.12, baseScale, scaleUp),
                cc.scaleTo(0.10, baseScale, scaleDown),
                cc.scaleTo(0.08, baseScale, baseScale)
            ),
            new cc.Sequence(
                cc.moveBy(0.12, 0, -button.height * (scaleUp - baseScale) * button.anchorY),
                cc.moveBy(0.10, 0, button.height * (scaleUp - scaleDown) * button.anchorY),
                cc.moveBy(0.08, 0, -button.height * (baseScale - scaleDown) * button.anchorY)
            )
        )).setFinalize(() => {
            button.setPosition(basePosition);
            button.setScale(baseScale);
        });
    },

    heroes: function () {
        const button = this;

        if (!button) {
            return;
        }

        const baseScale = button.scale;
        const basePosition = button.getPosition();

        const scaleUp = baseScale * 1.13;
        const scaleDown = baseScale * 0.95;

        button.runAction(new cc.Spawn(
            new cc.Sequence(
                cc.scaleTo(0.13, baseScale, scaleUp),
                cc.scaleTo(0.09, baseScale, scaleDown),
                cc.scaleTo(0.08, baseScale, baseScale)
            ),
            new cc.Sequence(
                cc.moveBy(0.13, 0, button.height * (scaleUp - baseScale) * (1 - button.anchorY)),
                cc.moveBy(0.09, 0, -button.height * (scaleUp - scaleDown) * (1 - button.anchorY)),
                cc.moveBy(0.08, 0, button.height * (baseScale - scaleDown) * (1 - button.anchorY))
            )
        )).setFinalize(() => {
            button.setPosition(basePosition);
            button.setScale(baseScale);
        });
    }
};